import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaCalendarAlt, FaUsers, FaStar, FaMountain } from 'react-icons/fa';
import { companyInfo } from '../../data/tourData';
import BookingForm from '../../components/common/BookingForm';
import './TourDetail.css';

const ValleyOfFlowers = () => {
  const tourData = {
    name: "Valley of Flowers Trek",
    duration: "05 Nights 06 Days",
    price: "₹ 8,999/-",
    image: "https://res.cloudinary.com/duym2bgp2/image/upload/v1754935182/qjoodhhsw4zukjx801pd.jpg",
    altitude: "3,858 meters",
    difficulty: "Moderate",
    region: "Uttarakhand",
    highlights: ["UNESCO World Heritage Site", "Over 500 species of wildflowers", "Stunning alpine meadows", "Snow-capped Himalayan peaks", "Rich biodiversity", "Photography opportunities"],
    bestTime: "June to August",
    description: "The Valley of Flowers Trek is a mesmerizing journey through one of India's most beautiful alpine valleys. Located in the Nanda Devi Biosphere Reserve, this UNESCO World Heritage Site is famous for its stunning meadows carpeted with hundreds of species of wildflowers."
  };

  return (
    <>
      <Helmet>
        <title>Valley of Flowers Trek - NomadTrailz</title>
        <meta name="description" content="Experience the magical Valley of Flowers Trek in Uttarakhand. Alpine meadows, rare flowers, and stunning Himalayan views await you." />
      </Helmet>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* Hero Section */}
        <section className="tour-hero">
          <div className="hero-background">
            <img
              src={tourData.image}
              alt={tourData.name}
            />
            <div className="hero-overlay"></div>
          </div>
          <div className="hero-content">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              {tourData.name}
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              A magical journey through alpine meadows carpeted with wildflowers
            </motion.p>
          </div>
        </section>

        {/* Tour Details */}
        <section className="tour-details">
          <div className="container">
            <div className="details-grid">
              <div className="tour-info">
                <motion.div
                  className="info-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6 }}
                >
                  <h2>Tour Overview</h2>
                  <p>{tourData.description}</p>
                  <p>
                    This trek takes you through the pristine landscapes of the Garhwal Himalayas, 
                    where you'll witness nature's most spectacular display of colors. The valley 
                    is home to over 500 species of wildflowers, making it a paradise for nature 
                    lovers and photographers.
                  </p>
                </motion.div>

                <motion.div
                  className="highlights-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                >
                  <h3>Highlights</h3>
                  <ul>
                    <li>UNESCO World Heritage Site</li>
                    <li>Over 500 species of wildflowers</li>
                    <li>Stunning alpine meadows</li>
                    <li>Snow-capped Himalayan peaks</li>
                    <li>Rich biodiversity</li>
                    <li>Photography opportunities</li>
                  </ul>
                </motion.div>

                <motion.div
                  className="itinerary-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                >
                  <h3>Travel Plan</h3>
                  <div className="day-item">
                    <h4>Day 1: Haridwar - Govindghat</h4>
                    <ul>
                      <li>Everyone is set for the Valley of flowers trek. All the enthusiastic trekkers shall gather at Haridwar Railway Station From the station.</li>
                      <li>We will all set forth on our journey to Govindghat which shall embark on the route via Joshimath and Devaprayag.</li>
                      <li>On the way, passing Devaprayag we shall witness the holy confluence of Bhagirathi and Alaknanda Rivers to form the River Ganges.</li>
                      <li>After this, we shall arrive at our destination Joshimath.</li>
                      <li>We can set ourselves up here, for the night.</li>
                      <li>After some fun interaction and activities, we shall have a healthy dinner and rest for the day.</li>
                    </ul>
                  </div>
                  <div className="day-item">
                    <h4>Day 2: Trek from Govindghat to Ghangaria</h4>
                    <ul>
                      <li>Today is the day, our Trek for Valley of flowers trek commences.</li>
                      <li>You shall wake up to an enchanting sunrise and after a breakfast, prepare yourselves for the trek.</li>
                      <li>We start trekking towards Ghangaria. The Valley of flowers trek till Ghangaria is a short 14km gradual ascent.</li>
                      <li>Once we reach Ghangaria, we shall settle here for the night & you are free to explore the tiny hamlet of Ghangaria.</li>
                      <li>We will some fun activities for you like games and exercises which should be fun at the same time, keep you fit and energized.</li>
                    </ul>
                  </div>
                  <div className="day-item">
                    <h4>Day 3: Trek from Ghangaria to Valley of Flowers and Back</h4>
                    <ul>
                      <li>We shall wake up to the pleasant morning of Ghangaria, full of excitement as we shall finally witness the pinnacle of this trek.</li>
                      <li>After a healthy and filling breakfast, we shall resume our trek ascending to 3,858m, to arrive at the Valley of flowers trek.</li>
                      <li>This soul-relishing sight shall take your breath away! A head of you lies nature's masterpiece spread out in form of a blanket of blooming flowers.</li>
                      <li>You are free to spend quality time at this fairytale land persuading activities like Yoga, Meditation, photography, etc.</li>
                      <li>We shall start trekking back to Ghangaria</li>
                      <li>We shall all have dinner together</li>
                    </ul>
                  </div>
                  <div className="day-item">
                    <h4>Day 4: Trek from Ghangaria to Hemkund Sahib</h4>
                    <ul>
                      <li>Today we shall trek to the famous Sikh shrine, Hemkund Sahib.</li>
                      <li>Therefore, after breakfast we shall trek on a moderately difficult steep climb for about 4 hours to reach Hemkund Sahib.</li>
                      <li>We shall spend some peaceful and soul calming moments here.</li>
                      <li>We will have our lunch here as well and post-lunch, we shall descend back to Ghangaria.</li>
                      <li>Once back, we shall have our dinner together here and rest for the night.</li>
                    </ul>
                  </div>
                  <div className="day-item">
                    <h4>Day 5: Trek from Ghangaria to Govindghat</h4>
                    <ul>
                      <li>Today we finally leave Ghangaria village.</li>
                      <li>After a delicious breakfast, we shall retrace the same trek route from Ghangaria to Govindghat.</li>
                      <li>It is an easy trail to descent to Poolna village.</li>
                      <li>If you wish, you can tour Auli in the evening along with fellow trekkers.</li>
                    </ul>
                  </div>
                  <div className="day-item">
                    <h4>Day 6: Drive from Govindghat to Haridwar</h4>
                    <ul>
                      <li>On our 6th day, our enriching experience comes to an end.</li>
                      <li>We shall leave Govindghat early so that everyone can leave from Haridwar to their respective destinations, timely.</li>
                      <li>Thus, our wonderful trek to the Valley of flowers comes to an end</li>
                    </ul>
                  </div>
                </motion.div>


                <motion.div
                  className="inclusions-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 1.0 }}
                >
                  <h3>Inclusions</h3>
                  <ul>
                    <li>Transportation support on Traveller, Ertiga, or Innova (depending on the size of the group) throughout the journey</li>
                    <li>Accommodation on sharing basis</li>
                    <li>All meals (Veg)</li>
                    <li>A well-experienced and certified trek leader</li>
                    <li>Cook</li>
                    <li>Supporting staff</li>
                    <li>Forest permit</li>
                  </ul>
                </motion.div>

                <motion.div
                  className="exclusions-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 1.2 }}
                >
                  <h3>Exclusions</h3>
                  <ul>
                    <li>Anything that has not been covered in the inclusions mentioned above</li>
                    <li>Porters or mules to carry your luggage. The cost per bag (10/12 kg) is 300 per day</li>
                    <li>Any kind of personal expenses</li>
                    <li>Any kind of personal medication</li>
                  </ul>
                </motion.div>

                <motion.div
                  className="things-to-carry-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 1.4 }}
                >
                  <h3>Things To Carry</h3>
                  <p className="carry-intro">All items listed are essential, unless marked as optional. Items are divided into five categories for your convenience.</p>
                  
                  <div className="carry-categories">
                    <div className="carry-category">
                      <h4><i className="fas fa-hiking"></i> Trekking Gear</h4>
                      <ul>
                        <li>Rucksack with rain cover</li>
                        <li>Day pack bag</li>
                        <li>Head torch with spare batteries</li>
                        <li>UV protection sunglasses</li>
                        <li>Water bottles: Two 1-liter bottles</li>
                      </ul>
                    </div>

                    <div className="carry-category">
                      <h4><i className="fas fa-shoe-prints"></i> Footwear</h4>
                      <ul>
                        <li>Non-skid, deep treaded, high-ankle trekking shoes: 1 pair</li>
                        <li>Lightweight slippers or sandals: 1 pair</li>
                      </ul>
                    </div>

                    <div className="carry-category">
                      <h4><i className="fas fa-tshirt"></i> Clothing</h4>
                      <ul>
                        <li>Quick-dry warm lower or track pants: 2</li>
                        <li>Full-sleeve T-shirts/sweatshirts: 1 for every 2 days of trekking</li>
                        <li>Thick woolen socks: 1 pair for every 2 days of trekking</li>
                        <li>Thermal body warmer (upper & lower): 1 set</li>
                        <li>Undergarments: 1 for each day of trekking</li>
                        <li>Warm jacket (closed at wrist & neck): 1</li>
                        <li>Full-sleeve sweater: 1</li>
                        <li>Rainwear (jacket & pants): 1 set</li>
                        <li>Waterproof, warm gloves: 1 pair</li>
                        <li>Woolen cap: 1</li>
                        <li>Sun-shielding hat: 1</li>
                      </ul>
                    </div>

                    <div className="carry-category">
                      <h4><i className="fas fa-soap"></i> Toiletries</h4>
                      <ul>
                        <li>Personal toiletries kit: Small towel, toilet paper, paper soap, bar soap, toothbrush, toothpaste, cold cream, etc.</li>
                        <li>Sunscreen lotion: Small pack</li>
                        <li>Lip balm: Small pack</li>
                      </ul>
                    </div>

                    <div className="carry-category">
                      <h4><i className="fas fa-utensils"></i> Utensils</h4>
                      <ul>
                        <li>Small, lightweight, leak-proof lunch box: 1</li>
                        <li>Plate: 1</li>
                        <li>Spoon: 1</li>
                        <li>Tea/coffee mug (plastic): 1</li>
                      </ul>
                    </div>

                    <div className="carry-category">
                      <h4><i className="fas fa-plus-circle"></i> Miscellaneous</h4>
                      <ul>
                        <li className="optional">Camera: (Optional)</li>
                        <li>Personal medicines: Bring plenty if needed; consult your doctor before the trek.</li>
                        <li className="optional">Dry fruits, nuts, chocolate bars (Optional)</li>
                      </ul>
                    </div>
                  </div>
                </motion.div>

                <motion.div
                  className="available-dates-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 1.6 }}
                >
                  <h3>Available Dates</h3>
                  <p><strong>DAILY DEPARTURES AVAILABLE FROM: JUNE TO AUGUST</strong></p>
                  <p>The Valley of Flowers trek is available during the monsoon season when the valley is in full bloom with colorful flowers. This is the best time to experience the natural beauty of this UNESCO World Heritage Site.</p>
                </motion.div>
              </div>

              <div className="booking-section">
                <motion.div
                  className="booking-card"
                  initial={{ opacity: 0, x: 30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6 }}
                >
                  <div className="price-info">
                    <span className="price">{tourData.price}</span>
                    <span className="duration">{tourData.duration}</span>
                  </div>

                  <div className="tour-features">
                    <div className="feature">
                      <FaMapMarkerAlt />
                      <span>{tourData.region}</span>
                    </div>
                    <div className="feature">
                      <FaCalendarAlt />
                      <span>Best Time: {tourData.bestTime}</span>
                    </div>
                    <div className="feature">
                      <FaUsers />
                      <span>Group Size: 10-15 people</span>
                    </div>
                    <div className="feature">
                      <FaStar />
                      <span>Difficulty: {tourData.difficulty}</span>
                    </div>
                    <div className="feature">
                      <FaMountain />
                      <span>Altitude: {tourData.altitude}</span>
                    </div>
                    <div className="feature">
                      <FaMapMarkerAlt />
                      <span>Trek Distance: 14 km (one way)</span>
                    </div>
                  </div>
                </motion.div>

                <motion.div
                  className="quick-info-card"
                  initial={{ opacity: 0, x: 30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                >
                  <h3>Quick Info</h3>
                  <div className="info-item">
                    <FaMountain />
                    <div>
                      <strong>Max Altitude:</strong>
                      <span>3,858 meters</span>
                    </div>
                  </div>
                  <div className="info-item">
                    <FaMapMarkerAlt />
                    <div>
                      <strong>Trek Distance:</strong>
                      <span>14 km (one way)</span>
                    </div>
                  </div>
                  <div className="info-item">
                    <FaStar />
                    <div>
                      <strong>Difficulty Level:</strong>
                      <span>Moderate</span>
                    </div>
                  </div>
                  <div className="info-item">
                    <FaCalendarAlt />
                    <div>
                      <strong>Best Season:</strong>
                      <span>June to August</span>
                    </div>
                  </div>
                </motion.div>

                <motion.div
                  className="cost-details-card"
                  initial={{ opacity: 0, x: 30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                >
                  <h3>Cost Details</h3>
                  <h4>Cost Per Person (Ex. Haridwar)</h4>
                  <ul>
                    <li><strong>Quad Sharing:</strong> ₹ 9,000 + 5% GST</li>
                    <li><strong>Triple Sharing:</strong> ₹ 9,500 + 5% GST</li>
                    <li><strong>Double Sharing:</strong> ₹ 10,000 + 5% GST</li>
                  </ul>
                </motion.div>

                <motion.div
                  className="pickup-card"
                  initial={{ opacity: 0, x: 30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.6 }}
                >
                  <h3>Pickup Points</h3>
                  <ul>
                    <li><strong>Haridwar:</strong> Haridwar railway station between 06:00 AM to 07:00 AM</li>
                  </ul>
                </motion.div>

                <motion.div
                  className="tour-highlights-card"
                  initial={{ opacity: 0, x: 30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.8 }}
                >
                  <h3>Tour Highlights</h3>
                  <ul>
                    <li>Trek through the UNESCO World Heritage Site</li>
                    <li>Witness the stunning Valley of Flowers in full bloom</li>
                    <li>Visit the sacred Hemkund Sahib Gurudwara</li>
                    <li>Experience the confluence of Alaknanda and Bhagirathi rivers</li>
                    <li>Explore the charming village of Ghangaria</li>
                    <li>Professional trek leader and support staff</li>
                    <li>All meals and accommodation included</li>
                  </ul>
                </motion.div>
              </div>

              <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <BookingForm 
                  tourName={tourData.name}
                  tourPrice={tourData.price}
                  tourDuration={tourData.duration}
                />
              </motion.div>
            </div>
          </div>
        </section>
      </motion.div>
    </>
  );
};

export default ValleyOfFlowers;
